import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { useForm } from 'react-hook-form'
import { PortalPassSchema } from '@/src/types'
import { PasswordField } from '@/src/components/form-components'
import Button from '@/src/components/button'

interface FormData {
  password: string
}
interface Props {
  onSubmit: (data: any) => void
  loading: boolean
}

const PortalPasswordForm = ({ onSubmit, loading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormData>({ resolver: yupResolver(PortalPassSchema) })

  const formSubmit = (data: FormData) => {
    onSubmit(data)
  }

  return (
    <form
      className="grid grid-cols-3 gap-4 mt-6 w-[22rem] sm:w-[37.5rem] "
      onSubmit={handleSubmit(formSubmit)}
    >
      <PasswordField
        validation={register('password')}
        label="Enter password to access portal"
        placeholder="Enter Password"
        divClass="col-span-full w-[34.5rem]"
        error={!!errors.password}
        helperText={errors.password?.message}
      />

      <div className="flex col-span-full gap-4 justify-end">
        <Button onClick={() => {}} type="submit" loading={loading} text="Submit" />
      </div>
    </form>
  )
}

export default PortalPasswordForm
